import './_interactive-map.scss';
import { responsive, debounce, hammerIt } from '../../../utilities';

export function initMarkers($markers, imgW) {
    $markers.each((_, marker) => {
        const $marker = $(marker);
        const t = Number($marker.attr('data-top'));
        const l = Number($marker.attr('data-left'));
        const defaultW = 1440;
        const defaultH = 900;
        const tPercent = (t / defaultH) * 100;
        const lPercent = (l / defaultW) * 100;
        $marker.css('left', `${lPercent}%`);
        $marker.css('top', `${tPercent}%`);
        responsive.transformScale(marker, imgW, 1440, 'left top');
    });
}

export function initFilters($filters, $markers, $intro, $imapMap) {
    let isIntroHide = false;
    $intro.show();
    $intro.removeClass('hide');
    $markers.find('.show').removeClass('show');
    $imapMap.removeClass(['map--default', 'map--alt']);

    $filters.each((_, filter) => {
        $(filter).on('click', () => {
            if (!isIntroHide) {
                $intro.addClass('hide');
                $intro.one('animationend', () => {
                    $intro.hide();
                });
                isIntroHide = true;
            }
            const target = $(filter).data('target');
            const map = $(filter).data('map');
            const $target = $markers.find(target);
            if (!$target.hasClass('show')) {
                $markers.find('.show').removeClass('show');
                $markers.find(target).addClass('show');
            }

            $imapMap.removeClass(['map--default', 'map--alt']);
            $imapMap.addClass('map--' + map);
        });
    });
}

$(() => {
    const $imap = $('.imap');
    if (!$imap.length) {
        return;
    }

    const $intro = $imap.find('.imap__intro');
    const $filters = $imap.find('.imap__filter');
    const $markers = $imap.find('.imap__markers');
    const $imgContainer = $imap.find('.imap__img-container'); // image container
    const $imapMap = $imap.find('.imap__map');

    function resize() {
        // initCSS();
        // exitIntro();
        responsive.breakAt({
            callback: () => {
                initMarkers($('.imap__marker'), $imgContainer.outerWidth());
                initFilters($filters, $markers, $intro, $imapMap);
                hammerIt(document.querySelector('.imap .imap__map-container '), 1, 2);
            },
            from: 'md',
        });
    }

    resize();
    window.addEventListener('resize', debounce(resize, 300));
});
